import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import styles from '../../TransferPage.module.scss';
import popup from '../../../components/popup/PopupModel.module.scss';
import hidden from 'assets/images/icn-show.svg';
import show from 'assets/images/icn-hidden.svg';
import Label from '../../../../constants/Label';
import { Button } from 'semantic-ui-react';
import { PopupModel } from '../../../components/popup/PopupModel';
import popClose from 'assets/images/pop-close.svg';
import { transcationActions, commonActions, ratesActions } from '../../../../stores/_actions';
import { selectErrorText } from 'selectors/error/ErrorSelector';
const Confirm = (props) => {
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  const [pin, setPin] = useState({ MPIN: '' });
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  // useEffect(() => {
  //   if (pin.MPIN != '') {
  //     setButtonActive(false);
  //   } else {
  //     setButtonActive(true);
  //   }
  //   location.state?.paymentPayload?.PayMode.Type == 'P' ? setButtonActive(false) : setButtonActive(true);
  // }, []);
  const paymentRequest = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      PayMode: location.state?.paymentPayload?.PayMode.Type,
      CustomerCode: profile?.CustomerCode,
      MRate: location.state?.rateOfTransfer?.data.MRate,
      DRate: location.state?.rateOfTransfer?.data.DRate,
      FCYAmt: location.state?.rateOfTransfer?.data.sFcyAmount,
      PIN: location.state?.password?.MPIN,
      LCYAmt: location.state?.rateOfTransfer?.data.sLcyAmount,
      PurposeCode: location.state?.paymentPayload?.PurposeCode,
      ServNo: location.state?.items?.ServNO,
      Charges: location.state?.rateOfTransfer?.data.Charge,
      SourceCode: location.state?.paymentPayload?.SourceCode,
      LocVsSndAmt: location.state?.rateOfTransfer?.data.LocVsSndAmt,
      NetAmount: location.state?.rateOfTransfer?.data.sNetAmount,
      PayBankCode: location.state?.paymentPayload?.PayBankCode,
      PaymentRefno: location.state?.paymentPayload?.paymentRefno,
    },
    Status: false,
    SessionID: sessionId,
    IdType: null,
    FileType: null,
    Langcode: '0001',
  };

  const validateCheckPayload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      CustomerCode: profile?.CustomerCode,
      ServNo: location.state?.items?.ServNO,
      FCAmt: String(location.state?.rateOfTransfer?.data.sFcyAmount),
      LCAmt: String(location.state?.rateOfTransfer?.data.sLcyAmount),
      NetAmt: String(location.state?.rateOfTransfer?.data.sNetAmount),
      RcvCurrency: location.state?.rateOfTransfer?.data?.RcvCurrency,
    },
    Status: false,
    SessionID: sessionId,
    IdType: null,
    FileType: null,
    Langcode: '0001',
  };

  const [password, setPaymentPayload] = useState();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPin((pin) => ({ ...pin, [name]: value }));
    setPaymentPayload((password) => pin);
    pin.MPIN.length == 8 ? setButtonActive(false) : setButtonActive(true);
    history.push({ pathname: '/transfer', state: { ...location.state, password } });
  };

  const backButton = () => {
    const menu = {
      beneficiary: false,
      amount: false,
      payment: true,
      confirm: false,
      transfer: false,
      print: false,
    };
    const menuValue = {
      ...location.state,
      menu,
      buttonActive,
    };
    history.push({ pathname: '/transfer', state: menuValue });
  };
  const [buttonActive, setButtonActive] = useState(false);
  const [modelPopup, openPopup] = useState(false);

  const result = useSelector((state) => state.saveRemit?.data);

  let openModal = false;

  if (location.state?.paymentPayload?.PayMode.Type == 'P' && result?.statusCode != 200) {
    openModal = true;
  } else {
    openModal = false;
  }

  useEffect(() => {
    if (pin.MPIN != '') {
      setButtonActive(false);
    } else {
      setButtonActive(true);
    }
    // location.state?.paymentPayload?.PayMode.Type == 'P' ? setButtonActive(false) : setButtonActive(true);
  }, []);

  const forwordButton = () => {
    dispatch(
      transcationActions.checkValidId(
        validateCheckPayload,
        paymentRequest,
        location.state?.paymentPayload?.PayMode.BaseURL,
        location.state?.items?.CurrencyCode
      )
    );
    // dispatch(transcationActions.saveRemittance(paymentRequest));
    location.state?.paymentPayload?.PayMode.Type == 'P' && location.state?.menu?.confirm == true ? openPopup(false) : openPopup(true);
    // history.push({ state: 'transaction complete' });
    dispatch(ratesActions.clearRatesData());
  };

  const [type, TextType] = useState('password');
  const InputType = () => (type == 'password' ? TextType('text') : TextType('password'));

  const hidePopup = () => {
    openPopup(false);
    dispatch(transcationActions.clearPreviousMessage());

    if (result && result.statusCode == '200') {
      const menu = {
        beneficiary: false,
        amount: false,
        payment: false,
        confirm: false,
        transfer: true,
        print: false,
      };
      const menuValue = {
        ...location.state,
        menu,
        buttonActive,
      };
      history.push({ pathname: '/transfer', state: menuValue });
    }
  };
  const menu = {
    beneficiary: false,
    amount: false,
    payment: false,
    confirm: true,
    transfer: false,
    print: false,
  };
  const menuValue = {
    ...location.state,
    menu,
    buttonActive,
  };
  const redirectToPass = () => {
    const menu = {
      beneficiary: false,
      amount: false,
      payment: false,
      confirm: true,
      transfer: false,
      print: false,
    };
    const menuValue = {
      ...location.state,
      menu,
      buttonActive,
    };
    localStorage.setItem('transfer', true);
    history.push({ pathname: '/forgot-password', state: menuValue });
  };

  const userProfile = useSelector((state) => state.getCustDetails.data);

  return (
    <>
      <div className={styles.confirm}>
        <div className={styles.confirm__item}>
          <h3>
            {userProfile?.FirstName} {userProfile?.LastName}
          </h3>
          <h6>{Label.Confirm.heading}</h6>
        </div>
        <div className={styles.confirm__item}>
          <h3 style={{ textAlign: 'center' }}>
            {location.state?.items?.BenfName}
            {location.state?.items?.Service === 'BANK TRANSFER' && location.state?.items?.AccountNo && (
              <>
                <br /> <span style={{ fontSize: '14px', color: 'black', margin: '0' }}> Account Number: {location.state?.items?.AccountNo}</span>
              </>
            )}
            {location.state?.items?.Service === 'BANK TRANSFER' && location.state?.items?.BenfBank && (
              <>
                <span style={{ fontSize: '14px', color: 'black', margin: '0' }}>{location.state?.items?.BenfBank}</span>
              </>
            )}
            {location.state?.items?.Service === 'BANK TRANSFER' && location.state?.items?.BenfBranch && (
              <>
                <span style={{ fontSize: '14px', color: 'black', margin: '0' }}>{location.state?.items?.BenfBranch}</span>
              </>
            )}
            {location.state?.items?.Service === 'BANK TRANSFER' && location.state?.items?.BicCode && (
              <>
                <span style={{ fontSize: '14px', color: 'black', margin: '0' }}>{location.state?.items?.BicCode}</span>
              </>
            )}
          </h3>
          <h6>{Label.Confirm.heading2}</h6>
        </div>
        <div className={styles.confirm__item}>
          <h3>{location.state?.paymentPayload?.PayMode.Description}</h3>
          <h6>{Label.Confirm.heading3}</h6>
        </div>
        <div className={styles.confirm__item}>
          <h3>
            <span>
              <img src={location.state?.items?.CurrencyFlagPath} alt="" />
              {location.state?.items?.CurrencyCode}
            </span>
            {location.state?.rateOfTransfer?.data?.sFcyAmount}
          </h3>
          <h6>{Label.Confirm.heading5}</h6>
        </div>
        <div className={styles.confirm__item}>
          <h3>
            <span className={styles.confirm__curname}>
              <span>KWD</span> <span>{location.state?.items?.CurrencyCode}</span>
            </span>
            1.00 = {location.state?.rateOfTransfer?.data?.DRate}
          </h3>
          <h6>
            <span>Indicative transfer rate</span>Transfer rate
          </h6>
        </div>
        <div className={styles.confirm__item}>
          <h3>
            {' '}
            {location.state?.rateOfTransfer?.data.sCharge} {location.state?.rateOfTransfer?.data?.RcvCurrency}
          </h3>
          <h6>{Label.Confirm.heading4}</h6>
        </div>
        <div className={styles.confirm__item2}>
          <div className={styles.amountPayable}>
            <div className={styles.amountPayable__payable}>
              <span>Amount Payable</span> KWD {location.state?.rateOfTransfer?.data?.sNetAmount}
            </div>
          </div>
        </div>
        {location.state?.paymentPayload?.PayMode.Type != 'T' ? (
          <>
            {' '}
            <div className={styles.confirm__item2}>
              <input
                type={type}
                placeholder="Transaction Password"
                name="MPIN"
                value={pin.MPIN}
                onChange={handleChange}
                onBlur={handleChange}
                onKeyUp={handleChange}
                className={styles.amountPayable}
                minLength="8"
                maxLength="8"
              />
              <img
                src={type == 'text' ? hidden : show}
                alt=""
                onClick={InputType}
                className={type == 'text' ? styles.confirm__hidden : styles.confirm__show}
              />
            </div>
            <div className={styles.confirm__rightalign}>
              <br />
              {/* If you have{' '} */}
              <span>
                <Link to={{ pathname: '/forgot-password', state: menuValue }}>Forgot Transaction Password</Link>.
              </span>
            </div>
          </>
        ) : (
          ''
        )}
      </div>
      <div className={styles.pageLeft__buttonCenter}>
        <Button onClick={backButton}>previous</Button>
        <Button className={buttonActive ? 'disabled' : ''} onClick={forwordButton}>
          {' '}
          PAY{' '}
        </Button>
      </div>

      {(modelPopup || openModal) && result ? (
        <div className={popup.dialogue}>
          <div className={popup.dialogue__wrap}>
            <img className={popup.dialogue__close} src={popClose} onClick={hidePopup} />
            {result?.statusCode == '200' || result?.statusCode == '401' ? (
              (localStorage.setItem('refno', JSON.stringify(result.response?.Refno)),
              (
                <>
                  <p>{result?.statusCode == '200' ? 'Transaction Completed' : result.message}</p>
                  <br />
                  <div className={styles.pageLeft__buttonCenter}>
                    {/* <Link onClick={hidePopup}>OK</Link> */}
                    <Button onClick={hidePopup} className="ui button">
                      {' '}
                      Ok
                    </Button>
                  </div>
                </>
              ))
            ) : (
              <p>Please wait while your transaction is processing...</p>
            )}
            {/* <p>It looks like your have not registered with us before. Please click below to register with before proceeding ahead.</p> */}
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default Confirm;
